import { getPreference } from '@openclassrooms/utils/config';
import { getEnvironment } from 'Modules/environment';
import { getActiveLang } from '@openclassrooms/translations';

import getIndexName, { IndexType, IndexName } from './getIndexName';

type Options = {
  indexType?: IndexType;
};

type AlgoliaConfiguration = {
  indexName?: IndexName;
  appId: string;
  apiKey: string;
};

type AlgoliaPreferences = {
  appId: string;
  learningContentApiKey: string;
  anonymizedApprenticesApiKey: string;
  publicJobPostingsApiKey: string;
};

function getPublicApiKey(indexName: IndexName, algoliaPreferences: AlgoliaPreferences): string {
  const indexNameToPublicApiKey = [
    {
      fragmentIndexName: 'talentsAnonymized',
      publicApiKey: algoliaPreferences.anonymizedApprenticesApiKey,
    },
    { fragmentIndexName: 'jobPostings', publicApiKey: algoliaPreferences.publicJobPostingsApiKey },
  ] as const satisfies ReadonlyArray<{ fragmentIndexName: string; publicApiKey: string }>;

  const { publicApiKey } =
    indexNameToPublicApiKey.find(({ fragmentIndexName }) =>
      indexName.includes(fragmentIndexName)
    ) || {};

  return publicApiKey ?? '';
}

function getConfiguration(options: Options = {}): AlgoliaConfiguration {
  const pref = (getPreference('algolia') || {}) as AlgoliaPreferences;

  let indexName: IndexName | undefined;

  if (options.indexType) {
    const environment = getEnvironment();
    indexName = getIndexName(options.indexType, {
      environment,
      language: getActiveLang(),
    });
  }

  let apiKey = pref.learningContentApiKey;

  if (indexName) {
    apiKey = getPublicApiKey(indexName, pref) || apiKey;
  }

  return {
    appId: pref.appId,
    apiKey,
    indexName,
  };
}

function getKey(key: keyof AlgoliaConfiguration) {
  return getConfiguration()[key];
}

export default {
  get: getConfiguration,
  getKey,
};
